// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type ReportErrorType = {
  title: string;
};

const ReportError = ({ title }: ReportErrorType) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      py={10}
      px="24px"
      gap="24px"
      textAlign="center"
    >
      <Typography fontSize="24px" fontWeight={600}>
        {title}
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap="8px"
      >
        <Typography fontSize="20px">
          {t("Please contact us at")} <b>support@retinalogik.ca</b>{" "}
          {t("to obtain the data.")}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReportError;
